module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-72x72-717f5c7131baf193e49e39bde20c5289.png";